import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    left: -16,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
  },
  top: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 8,
  },
  filtersContainer: {
    marginRight: 16,
  },
  filter: {
    width: 88,
    fontSize: 10,
    color: '#000000',
    borderColor: '#C4C6C9',
    marginRight: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: 'transparent',
  },
  activeFilter: {
    color: '#333333',
    borderColor: '#007AFF',
    boxShadow: '0px 4px 4px rgba(0, 122, 255, 0.2)',
    fontWeight: 700,
  },
  addDelay: {
    fontSize: 10,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    marginRight: 8,
    color: theme.palette.common.white,
    backgroundColor: theme.charts.urgent,
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.25)',
    transition: 'background-color 0.5s',
    '&:hover': {
      backgroundColor: '#B34040',
    },
  },
  yearContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 40,
  },
  year: {
    fontSize: 12,
    fontWeight: 'bold',
  },
  decrease: {
    marginRight: 4,
  },
  increase: {
    marginLeft: 4,
  },
  scheduleContainer: {
    display: 'grid',
    width: '94%',
    height: '100%',
    gridTemplateColumns: '6% 94%',
    gridTemplateRows: '10% 90%',
    gridTemplateAreas: "'. days''months content'",
    marginBottom: 16,
  },
  days: {
    gridArea: 'days',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottomStyle: 'solid',
    borderBottomWidth: 2,
    borderBottomColor: '#C4C6C9',
  },
  daysLabel: {
    position: 'relative',
    bottom: -6,
    fontSize: 12,
    textAlign: 'center',
    borderBottomStyle: 'solid',
    borderBottomColor: '#007AFF',
  },
  months: {
    gridArea: 'months',
    display: 'grid',
    gridTemplateColumns: '100%',
    gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    gridTemplateAreas:
      "'mon_jan''mon_feb''mon_mar''mon_apr''mon_may''mon_jun''mon_jul''mon_aug' 'mon_sep' 'mon_oct' 'mon_nov' 'mon_dec'",
    borderRightStyle: 'solid',
    borderRightWidth: 2,
    borderRightColor: '#C4C6C9',
    padding: 2,
    marginTop: 2,
  },
  monthsLabel: {
    margin: 4,
    textAlign: 'center',
    fontSize: 12,
    borderBottomStyle: 'solid',
    borderBottomColor: '#007AFF',
  },
  content: {
    gridArea: 'content',
    display: 'grid',
    gridTemplateColumns: '100%',
    gridTemplateRows: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
    gridTemplateAreas:
      "'jan''feb''mar' 'apr' 'may' 'jun' 'jul' 'aug' 'sep' 'oct' 'nov' 'dec'",
    padding: 2,
    marginTop: 2,
  },
  data: {
    width: '100%',
    height: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: 4,
    marginTop: 2,
    marginBottom: 6,
  },
  value: {
    height: 20,
    borderRadius: 4,
    marginTop: 2,
    marginBottom: 4,
    marginLeft: 2,
  },
  weeksLabel: {
    position: 'absolute',
    top: 0,
    fontSize: 12,
    textAlign: 'center',
  },
}));
